export const V2_SIGNUP_PATH = "/signup";
